import React from 'react';
import { createRoute, Outlet } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';
import Layout from '../layout/Layout';
import { requireAuth } from './guards';
import Loading from '../components/loading/Loading';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  id: '_authenticated',
  beforeLoad: requireAuth(),
  component: () => (
    <Layout>
      <React.Suspense fallback={<Loading />}>
        <Outlet />
      </React.Suspense>
    </Layout>
  ),
});
